export default __webpack_public_path__ + "media/images/community/background-light-39c87a492ca47694bca7a42d148d55e6.svg";